import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	margin-top: 20px;
`;

const StyledCallsList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

const StyledNoCallsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 395px;

	${Text} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
		text-align: center;
	}
`;

export { StyledCallsList, StyledContainer, StyledNoCallsContainer };
